import { httpClient, getApplicationHeaders } from "@utils";
import { Filter } from "@api-types/betting-activity/Filter";
import { UserActivityResponse } from "@api-types/betting-activity/UserActivityResponse";
import { BettingActivityResponse } from "@api-types/betting-activity/BettingActivityResponse";

export class BettingActivityService {
	getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	async fetchUserAccountActivity(
		filter: Filter
	): Promise<UserActivityResponse> {
		return await httpClient.post(
			`${WEBPACK_BASE_ADDRESS}platform/reports/AccountActivityReview`,
			JSON.stringify(filter),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	async fetchUserBettingActivity(
		filter: Filter
	): Promise<BettingActivityResponse> {
		return await httpClient.post(
			`${WEBPACK_BASE_ADDRESS}platform/reports/BettingActivityReview`,
			JSON.stringify(filter),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}
}
